import React, { useRef, useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

import Header from '../components/Header';
import Footer from '../components/Footer';

import image1 from '../assest/Gallery/image1.png';
import image2 from '../assest/Gallery/image2.jpg';
import image3 from '../assest/Gallery/image3.jpg';
import image4 from '../assest/Gallery/image4.png';
import image5 from '../assest/Gallery/image5.jpg';
import image6 from '../assest/Gallery/image6.png';
import image01 from '../assest/Records/Dentalcheckup/image2.png';
import video1 from '../assest/capms/redcross_images/video.MP4';

import image7 from '../assest/capms/redcross_images/image15.JPG';
import image8 from '../assest/capms/redcross_images/image17.JPG';
import image9 from '../assest/capms/redcross_images/image18.JPG';
import image10 from '../assest/capms/redcross_images/image20.JPG';
import image11 from '../assest/capms/redcross_images/image21.JPG';
import image14 from '../assest/capms/redcross_images/image7.JPG';
import image15 from '../assest/capms/redcross_images/image8.JPG';
import image16 from '../assest/capms/redcross_images/image9.JPG';
import image17 from '../assest/capms/redcross_images/image10.JPG';
import image18 from '../assest/capms/redcross_images/image11.JPG';
import image19 from '../assest/capms/redcross_images/image12.JPG';
import image20 from '../assest/capms/redcross_images/image13.JPG';
import image21 from '../assest/capms/redcross_images/image14.JPG';

const galleryItems = [
  { id: 1, type: 'image', src: image2, title: 'Free Rural Dental Camps' },
  { id: 2, type: 'image', src: image1, title: 'Guinness World Record Event' },
  { id: 3, type: 'image', src: image3, title: 'Mobile camp Inauguration Ceremony' },
  { id: 4, type: 'image', src: image4, title: 'Large scale Blood Donation Camp' },
  { id: 5, type: 'image', src: image5, title: 'Mobile dental checkup' },
  { id: 6, type: 'image', src: image6, title: 'Awareness Camp' },
  { id: 7, type: 'video', src: video1, title: 'Medical Camp Highlights' },
  { id: 8, type: 'video', src: video1, title: 'Medical Camp Highlights' },
  { id: 9, type: 'image', src: image7, title: 'Interaction about Awareness' },
  { id: 10, type: 'image', src: image8, title: 'Redcross Camp Volunteers' },
  { id: 11, type: 'image', src: image9, title: 'Redcross Camp Volunteers' },
  { id: 12, type: 'image', src: image10, title: 'Medical Camp Outreach' },
  { id: 13, type: 'image', src: image11, title: 'Community Engagement' },
  { id: 15, type: 'image', src: image14, title: 'Medical Camp attendies' },
  { id: 16, type: 'image', src: image15, title: 'Inauguration Ceremony' },
  { id: 17, type: 'image', src: image16, title: 'Redcross award felicitation' },
  { id: 18, type: 'image', src: image17, title: 'Paper Clipping during COVID-19' },
  { id: 19, type: 'image', src: image18, title: 'Oath Taking Ceremony' },
  { id: 20, type: 'image', src: image19, title: 'Guinness World record felicitation at LOYOLA college' },
  { id: 21, type: 'image', src: image20, title: 'Health Awareness Campaign for children' },
  { id: 22, type: 'image', src: image21, title: 'Medical Camp Impact' },
  { id: 23, type: 'image', src: image01, title: 'Blood donation camp success meet' },
];

// Video Component (unchanged logic + motion wrapper)
const VideoThumbnail = ({ item, onClick }) => {
  const videoRef = useRef(null);

const handleMouseEnter = async () => {
  const video = videoRef.current;

  if (!video) return;

  try {
    video.muted = true;
    video.currentTime = 0;

    if (video.readyState < 2) {
      await video.load();
    }

    await video.play();
  } catch (err) {
    console.log('Video play failed:', err);
  }
};

const handleMouseLeave = () => {
  const video = videoRef.current;

  if (!video) return;

  video.pause();
  video.currentTime = 0;
};
useEffect(() => {
  const timer = setTimeout(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant'
    });
  }, 500);

  return () => clearTimeout(timer);
}, []);
  return (
    <motion.div
      className="relative h-full w-full cursor-pointer"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onClick={(e) => {
        e.stopPropagation();
        onClick();
      }}
      whileHover={{ scale: 1.02 }}
    >
<video
  ref={videoRef}
  muted
  loop
  playsInline
  preload="auto"
  onLoadedData={() => console.log('Video Loaded')}
  className="h-full w-full object-cover"
>
  <source src={item.src} type="video/mp4" />
</video>

      <div className="absolute inset-0 bg-black/20 flex items-center justify-center pointer-events-none">
        <div className="rounded-full bg-white/90 p-3 shadow-lg text-black text-xl">
          ▶
        </div>
      </div>
    </motion.div>
  );
};
const ViewMore = () => {
  const [selectedMedia, setSelectedMedia] = useState(null);

  return (
    <motion.div
      className="min-h-screen bg-gray-50 pt-24 sm:pt-28 px-4 sm:px-6 lg:px-8"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.6 }}
    >

      <Header />

      <div className="max-w-7xl mx-auto">

        {/* HEADER */}
        <motion.div
          className="mb-12 text-center"
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            Gallery
          </h1>
          <p className="text-gray-500 max-w-3xl mx-auto text-base sm:text-lg">
            Our achievements and impact in pictures.
          </p>
        </motion.div>

        {/* GRID */}
        <div className="grid gap-4 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 mb-16">

          {galleryItems.map((item, i) => (
            <motion.div
              key={item.id}
              className="relative group overflow-hidden rounded-2xl shadow-lg cursor-pointer"
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.5, delay: i * 0.05 }}
              whileHover={{ scale: 1.02 }}
              onClick={() => setSelectedMedia(item)}
            >

              <div className="relative h-64 sm:h-72 lg:h-80 overflow-hidden bg-slate-100">

{item.type === 'image' ? (
  <motion.img
    src={item.src}
    alt={item.title}
    className="h-full w-full object-cover"
    whileHover={{ scale: 1.08 }}
  />
) : (
  <VideoThumbnail
    item={item}
    onClick={() => setSelectedMedia(item)}
  />
)}

                {/* overlay */}
                <div className="absolute inset-0 bg-black/10 opacity-0 group-hover:opacity-100 transition-opacity flex items-end p-6 pointer-events-none">
                  <p className="text-white font-medium text-lg">
                    {item.title}
                  </p>
                </div>

              </div>

            </motion.div>
          ))}

        </div>
      </div>

      {/* LIGHTBOX */}
      <AnimatePresence>
        {selectedMedia && (
          <motion.div
            className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 p-4"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setSelectedMedia(null)}
          >

            <motion.div
              className="relative w-full max-w-6xl bg-black rounded-2xl overflow-hidden"
              initial={{ scale: 0.8 }}
              animate={{ scale: 1 }}
              exit={{ scale: 0.8 }}
            >

              <button
                className="absolute top-4 right-4 text-white z-50"
                onClick={() => setSelectedMedia(null)}
              >
                ✕
              </button>

              {selectedMedia.type === 'image' ? (
                <img
                  src={selectedMedia.src}
                  className="w-full max-h-[90vh] object-contain"
                />
              ) : (
<video
  controls
  autoPlay
  playsInline
  className="w-full max-h-[90vh]"
>
  <source src={selectedMedia.src} type="video/mp4" />
</video>
              )}

              <div className="absolute bottom-0 w-full bg-black/60 p-4 text-white">
                {selectedMedia.title}
              </div>

            </motion.div>

          </motion.div>
        )}
      </AnimatePresence>

     <div className="-mx-4 sm:-mx-6 lg:-mx-8">
  <Footer />
</div>

    </motion.div>
  );
};

export default ViewMore;